import jwtDecode from 'jwt-decode'
import moment from 'moment'
import { get } from 'lodash'
import { getActiveOrganization } from 'utils/token'
import store from 'store'

const config = require('../../config')
const LOAD = 'dofe-web/auth/LOAD'
const LOAD_SUCCESS = 'dofe-web/auth/LOAD_SUCCESS'
const LOAD_FAIL = 'dofe-web/auth/LOAD_FAIL'
const LOGIN = 'dofe-web/auth/LOGIN'
const LOGIN_SUCCESS = 'dofe-web/auth/LOGIN_SUCCESS'
const LOGIN_FAIL = 'dofe-web/auth/LOGIN_FAIL'
const LOGOUT = 'dofe-web/auth/LOGOUT'
const LOGOUT_SUCCESS = 'dofe-web/auth/LOGOUT_SUCCESS'
const LOGOUT_FAIL = 'dofe-web/auth/LOGOUT_FAIL'
const SAVE_USER = 'dofe-web/auth/SAVE_USER'
const SAVE_USER_SUCCESS = 'dofe-web/auth/SAVE_USER_SUCCESS'
const SAVE_USER_FAIL = 'dofe-web/auth/SAVE_USER_FAIL'
const SET_ORGANIZATION = 'dofe-web/auth/SET_ORGANIZATION'
const REMOVE_ORGANIZATION = 'dofe-web/auth/REMOVE_ORGANIZATION'

const REFRESH = 'dofe-web/auth/REFRESH'
const REFRESH_SUCCESS = 'dofe-web/auth/REFRESH_SUCCESS'
const REFRESH_FAIL = 'dofe-web/auth/REFRESH_FAIL'

const GET_CSFR_TOKEN = 'dofe-web/auth/GET_CSFR_TOKEN'
const GET_CSFR_TOKEN_SUCCESS = 'dofe-web/auth/GET_CSFR_TOKEN_SUCCESS'
const GET_CSFR_TOKEN_FAIL = 'dofe-web/auth/GET_CSFR_TOKEN_FAIL'

const USER_AUTOLOGIN = 'dofe-web/auth/USER_AUTOLOGIN'
const USER_AUTOLOGIN_SUCCESS = 'dofe-web/auth/USER_AUTOLOGIN_SUCCESS'
const USER_AUTOLOGIN_FAIL = 'dofe-web/auth/USER_AUTOLOGIN_FAIL'
const SET_AUTOLOGGING_FLAG = 'dofe-web/auth/SET_AUTOLOGGING_FLAG'
const SET_PAGE_CODE = 'dofe-web/auth/SET_PAGE_CODE'

const initialState = {
  loaded: false,
  organization: {
    id: null,
    name: null,
    userType: null,
    hierarchyLevelType: {}
  },
  refreshingToken: false,
  loginPageCode: null
}

export default function reducer(state = initialState, action = {}) {
  let tempUser
  let extendBy
  let currentUnixTime

  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      }
    case LOAD_SUCCESS:
      tempUser = config.autoLogin ? state.user : null

      return {
        ...state,
        loading: false,
        loaded: true,
        user: action.result ? action.result : tempUser,
        organization: getActiveOrganization(action.result)
      }
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case LOGIN:
      return {
        ...state,
        loggingIn: true
      }
    case LOGIN_SUCCESS:
      return {
        ...state,
        loggingIn: false,
        user: action.result
      }
    case LOGIN_FAIL:
      return {
        ...state,
        loggingIn: false,
        user: null,
        loginError: action.error
      }
    case LOGOUT:
      return {
        ...state,
        loggingOut: true
      }
    case LOGOUT_SUCCESS:
      store.remove(`activeOrganization-${get(state, 'user.personId')}`)

      return {
        ...state,
        loggingOut: false,
        user: null
      }
    case LOGOUT_FAIL:
      return {
        ...state,
        loggingOut: false,
        logoutError: action.error
      }
    case SAVE_USER:
      return {
        ...state
      }
    case SAVE_USER_SUCCESS:
      return {
        ...state,
        user: action.result
      }
    case SAVE_USER_FAIL:
      return {
        ...state
      }
    case USER_AUTOLOGIN:
      return {
        ...state
      }
    case USER_AUTOLOGIN_SUCCESS:
      return {
        ...state,
        autologin: action.result
      }
    case USER_AUTOLOGIN_FAIL:
      return {
        ...state,
      }
    case SET_AUTOLOGGING_FLAG:
      return {
        ...state,
        autoLogging: action.isAutoLogging
      }
    case SET_ORGANIZATION:
      store.set(
        `activeOrganization-${get(state, 'user.personId')}`,
        JSON.stringify(action.organization)
      )

      return {
        ...state,
        organization: action.organization
      }
    case REMOVE_ORGANIZATION:
      store.remove(`activeOrganization-${get(state, 'user.user')}`)

      return {
        ...state,
        organization: {}
      }
    case REFRESH:
      return {
        ...state,
        refreshingToken: true
      }
    case REFRESH_SUCCESS:
      currentUnixTime = moment().unix() * 1000
      extendBy = action.result.expires_in * 1000

      if (!get(state, 'user.access_token')) {
        return {
          ...state,
          refreshingToken: false,
          user: {}
        }
      }

      return {
        ...state,
        refreshingToken: false,
        user: {
          ...state.user,
          ...action.result,
          exp: currentUnixTime + extendBy
        }
      }
    case REFRESH_FAIL:
      return {
        ...state,
        refreshingToken: false,
        user: null,
        loginError: action.error
      }
    case SET_PAGE_CODE:
      return {
        ...state,
        loginPageCode: action.pageCode
      }
    default:
      return state
  }
}

export function isLoaded(globalState) {
  return globalState.auth && globalState.auth.loaded
}

export function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: client => client.get('/loadAuth')
  }
}

/* eslint-disable */
export function login(data) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: client =>
      client.post('/authenticate', {
        data: {
          ...data,
          client_id: 'backoffice-web'
        }
      })
  }
}
/* eslint-enable */

export function saveUser(response) {
  return {
    types: [SAVE_USER, SAVE_USER_SUCCESS, SAVE_USER_FAIL],
    promise: client =>
      client.post('/save-user', {
        data: {
          ...response,
          ...jwtDecode(response.access_token)
        }
      })
  }
}

export function userAutologin(loginId) {
  return {
    types: [USER_AUTOLOGIN, USER_AUTOLOGIN_SUCCESS, USER_AUTOLOGIN_FAIL],
    promise: client =>
      client.post('/user-autologin', {
        data: loginId
      })
  }
}

export function setAutoLoggingFlag(isAutoLogging) {
  return {
    type: SET_AUTOLOGGING_FLAG,
    isAutoLogging
  }
}

export function logout() {
  return {
    types: [LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAIL],
    promise: client => client.post('/logout')
  }
}

export function setActiveOrganization(organization) {
  return {
    type: SET_ORGANIZATION,
    organization
  }
}

export function removeOrganization() {
  return {
    type: REMOVE_ORGANIZATION
  }
}

export function refreshAccessToken(token) {
  return {
    types: [REFRESH, REFRESH_SUCCESS, REFRESH_FAIL],
    promise: client =>
      client.post('/tokens', {
        data: {
          refresh_token: token // eslint-disable-line
        },
        removeToken: true
      })
  }
}

export function getCSRFToken() {
  return {
    types: [GET_CSFR_TOKEN, GET_CSFR_TOKEN_SUCCESS, GET_CSFR_TOKEN_FAIL],
    promise: client => client.get('api/tokens/csrf/get')
  }
}

export function getORBg02CSRFToken() {
  return {
    types: [GET_CSFR_TOKEN, GET_CSFR_TOKEN_SUCCESS, GET_CSFR_TOKEN_FAIL],
    promise: client => client.get('apiv2/authentication/token/csrf/get')
  }
}


export function setPageCode(pageCode) {
  return {
    type: SET_PAGE_CODE,
    pageCode
  }
}
